import { useBulkVerifyAnalyses, useBulkDeleteAnalyses } from './mutations';

export default function useAdminHistoryActions() {
  const { mutateAsync: bulkVerify, isPending: isVerifying } =
    useBulkVerifyAnalyses();
  const { mutateAsync: bulkDelete, isPending: isDeleting } =
    useBulkDeleteAnalyses();

  return {
    handleBulkVerification: bulkVerify,
    handleBulkDelete: bulkDelete,
    isPending: isVerifying || isDeleting,
  };
}
